import { writeBatch, type DocumentReference } from 'firebase/firestore'
import { getFirestoreInstance } from '../firebase'

const MAX_OPS_PER_BATCH = 400

export type BatchWriteOp =
  | { type: 'set'; ref: DocumentReference; data: object }
  | { type: 'delete'; ref: DocumentReference }

/** Commit set/delete ops in chunks under Firestore's 500-op batch limit. */
export async function commitWriteOps(ops: BatchWriteOp[]): Promise<void> {
  if (ops.length === 0) return
  const db = getFirestoreInstance()
  for (let i = 0; i < ops.length; i += MAX_OPS_PER_BATCH) {
    const batch = writeBatch(db)
    for (const op of ops.slice(i, i + MAX_OPS_PER_BATCH)) {
      if (op.type === 'delete') batch.delete(op.ref)
      else batch.set(op.ref, op.data)
    }
    await batch.commit()
  }
}
